<template lang="pug">
.register-row
  .register-group.w-100(v-if="_value != undefined")
    .register-key
      span.key-name 権限（使用機能）
    //- v-forを使用したいが、仕様で並び順指定があるためループは使用しない
    .function.w-100(v-if="_useFamilyService && _isOverLightPlan")
      .service-title.d-flex.flex-row.align-items-center.mb-2
        .function-name.flex-grow-1 家族連絡サービス
      //- 施設情報（修正）
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("facilitiesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.facilitiesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 部屋情報（修正等）
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("roomsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.roomsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 家族の使用機能（変更）
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("useFamilyFunctionsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.useFamilyFunctionsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 家族の使用機能（個別設定）
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("individuallyUseFamilyFunctionsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.individuallyUseFamilyFunctionsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 施設関係者の使用機能（変更）
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("useOtherUserFunctionsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.useOtherUserFunctionsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 利用者
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("residentsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.residentsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 家族ユーザー
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("familiesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.familiesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 施設関係者
      .content.d-flex.flex-row.align-items-center(v-if="isOverBasicPlan()")
        .function-name.flex-grow-1
          span {{ getFunctionName("otherUserGroupsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.otherUserGroupsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 宛先グループ（修正等）
      .content.d-flex.flex-row.align-items-center(v-if="isOverFreePlan()")
        .function-name.flex-grow-1
          span {{ getFunctionName("sendMessageGroupsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.sendMessageGroupsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- メッセージ送信
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("sendMessagesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.sendMessagesFunction")
        .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showSendMessagesFunction, 'not-collapsed': showSendMessagesFunction }")
          button.btn.toggle-text(@click="changeShowSendMessagesFunction()") 詳細
      transition(name="detail-btn-transition")
        FormInputStandardUserSendMessagesFunction(v-if="showSendMessagesFunction == true" v-model="_value.sendMessagesFunction" serviceType="families")
      //- 文書送付
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("sendDocumentsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.sendDocumentsFunction")
        .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showSendDocumentsFunction, 'not-collapsed': showSendDocumentsFunction }")
          button.btn.toggle-text(@click="changeShowSendDocumentsFunction()") 詳細
      transition(name="detail-btn-transition")
        FormInputStandardUserSendDocumentsFunction(v-if="showSendDocumentsFunction == true" v-model="_value.sendDocumentsFunction")
      //- 受信メッセージ
      .content.d-flex.flex-row.align-items-center(v-if="showOpinionMessageMenu()")
        .function-name.flex-grow-1
          span {{ getFunctionName("receiveMessagesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.receiveMessagesFunction")
        .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showReceiveMessagesFunction, 'not-collapsed': showReceiveMessagesFunction }")
          button.btn.toggle-text(@click="changeShowReceiveMessagesFunction()") 詳細
      transition(name="detail-btn-transition")
        FormInputStandardUserReceiveMessagesFunction(v-if="showReceiveMessagesFunction == true" v-model="_value.receiveMessagesFunction")
      //- 面会予約
      .content.d-flex.flex-row.align-items-center(v-if="showMenuOfPermitted('onlineReservation') || showMenuOfPermitted('reservation')")
        .function-name.flex-grow-1
          span {{ getFunctionName("reservationsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.reservationsFunction")
        .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showReservationsFunction, 'not-collapsed': showReservationsFunction }")
          button.btn.toggle-text(@click="changeShowReservationsFunction()") 詳細
      transition(name="detail-btn-transition")
        FormInputStandardUserReservationsFunction(v-if="showReservationsFunction == true" v-model="_value.reservationsFunction")
      //- 外出外泊届け
      .content.d-flex.flex-row.align-items-center(v-if="showMenuOfPermitted('outing') && _isOverLightPlan")
        .function-name.flex-grow-1
          span {{ getFunctionName("outingsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.outingsFunction")
        .d-flex.flex-row-reverse.detail-btn
      transition(name="detail-btn-transition")
        FormInputStandardUserReservationsFunction(v-if="showReservationsFunction == true" v-model="_value.reservationsFunction")
      //- イベント情報
      .content.d-flex.flex-row.align-items-center(v-if="showMenuOfPermitted('event') && isOverBasicPlan()")
        .function-name.flex-grow-1
          span {{ getFunctionName("eventsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.eventsFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 写真印刷依頼
      .content.d-flex.flex-row.align-items-center(v-if="showMenuOfPermitted('picture') && isOverBasicPlan()")
        .function-name.flex-grow-1
          span {{ getFunctionName("picturesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.picturesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 介護記録
      .content.d-flex.flex-row.align-items-center(v-if="showMenuOfPermitted('careimage') && isOverBasicPlan()")
        .function-name.flex-grow-1
          span {{ getFunctionName("careimagesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.careimagesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 空床スケジュール
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("roomSchedulesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.roomSchedulesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- アンケート
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("questionnairesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.questionnairesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 安否確認
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("safetyConfirmationFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.safetyConfirmationFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 家族の使用状況
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("familyMessagesFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.familyMessagesFunction")
        .d-flex.flex-row-reverse.detail-btn
      //- 活動履歴
      //- 待機者サービス、他事業所連携サービスが使用不可の場合、家族連絡サービスの項目として表示する
      .content.d-flex.flex-row.align-items-center(v-if="!_useWaiterService && !_useOtherOfficeService")
        .function-name.flex-grow-1
          span {{ getFunctionName("reportsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.reportsFunction")
        .d-flex.flex-row-reverse.detail-btn
      .mb-3
      .separator(style="border-top: 1px solid #606060;")
      .mb-3
    
    .function.w-100(v-if="_useWaiterService && _isOverWaiterBasicPlan")
      //- 入所者募集管理サービス
      .service-title.d-flex.flex-row.align-items-center.mb-2
        .function-name.flex-grow-1
          span {{ getFunctionName("useWaiterService") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.useWaiterService")
        .d-flex.flex-row-reverse.detail-btn
      Transition(name="detail-btn-transition")
        div(v-if="_value.functions.useWaiterService")
          //- 待機者
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("waitersFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.waitersFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- メッセージ送信
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("waiterSendMessagesFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.waiterSendMessagesFunction")
            .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showWaiterSendMessagesFunction, 'not-collapsed': showWaiterSendMessagesFunction }")
              button.btn.toggle-text(@click="changeShowWaiterSendMessagesFunction()") 詳細
          transition(name="detail-btn-transition")
            FormInputStandardUserSendMessagesFunction(v-if="showWaiterSendMessagesFunction == true" v-model="_value.sendMessagesFunction" serviceType="waiters")
          //- 受信メッセージ
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("waiterReceiveMessagesFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.waiterReceiveMessagesFunction")
            .d-flex.flex-row-reverse.detail-btn(:class="{ 'collapsed': !showWaiterReceiveMessagesFunction, 'not-collapsed': showWaiterReceiveMessagesFunction }")
              button.btn.toggle-text(@click="changeShowWaiterReceiveMessagesFunction()") 詳細
          transition(name="detail-btn-transition")
            FormInputStandardUserWaiterReceiveMessagesFunction(v-if="showWaiterReceiveMessagesFunction == true" v-model="_value.waiterReceiveMessagesFunction")
          //- フォロワー
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("waiterFollowersFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.waiterFollowersFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- 施設見学
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("inspectionReservationsFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.inspectionReservationsFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- お問い合わせ
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("recruitmentContactsFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.recruitmentContactsFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- 活動履歴
          //- 家族連絡サービス、他事業所連携サービスが使用不可の場合、待機者サービスの項目として表示する
          .content.d-flex.flex-row.align-items-center(v-if="!_useFamilyService && !_useOtherOfficeService")
            .function-name.flex-grow-1
              span {{ getFunctionName("reportsFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.reportsFunction")
            .d-flex.flex-row-reverse.detail-btn
      .mb-3
      .separator(style="border-top: 1px solid #606060;")
      .mb-3

    //- 他事業所連携サービス
    .function.w-100(v-if="_useOtherOfficeService")
      //- 他事業所連携サービス
      .service-title.d-flex.flex-row.align-items-center.mb-2
        .function-name.flex-grow-1
          span {{ getFunctionName("useOtherOfficeConnectionService") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.useOtherOfficeConnectionService")
        .d-flex.flex-row-reverse.detail-btn
      Transition(name="detail-btn-transition")
        div(v-if="_value.functions.useOtherOfficeConnectionService")
          //- トップ（招待・操作）
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("otherOfficeTopPageFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.otherOfficeTopPageFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- メッセージ
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("otherOfficeMessagesFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.otherOfficeMessagesFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- オンライン会議
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("otherOfficeOnlineMeetingsFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.otherOfficeOnlineMeetingsFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- 空床情報
          .content.d-flex.flex-row.align-items-center
            .function-name.flex-grow-1
              span {{ getFunctionName("otherOfficeRoomSchedulesFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.otherOfficeRoomSchedulesFunction")
            .d-flex.flex-row-reverse.detail-btn
          //- 活動履歴
          //- 家族連絡サービス、待機者サービスが使用不可の場合、他事業所連携サービスの項目として表示する
          .content.d-flex.flex-row.align-items-center(v-if="!_useFamilyService && !_useWaiterService")
            .function-name.flex-grow-1
              span {{ getFunctionName("reportsFunction") }}
            .d-flex.flex-row-reverse
              UsableFunctionSwitch(v-model="_value.functions.reportsFunction")
            .d-flex.flex-row-reverse.detail-btn
      .mb-3
      .separator(style="border-top: 1px solid #606060;")
      .mb-3

    //- 家族連絡サービス、待機者サービス、他事業所連携サービスの全てを使用可能な場合、サービス共通を別表示する
    .function.w-100(v-if="_showCommonreportsFunction")
      .service-title.d-flex.flex-row.align-items-center.mb-2
        .function-name.flex-grow-1 全サービス共通
      //- 活動履歴
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ getFunctionName("reportsFunction") }}
        .d-flex.flex-row-reverse
          UsableFunctionSwitch(v-model="_value.functions.reportsFunction")
        .d-flex.flex-row-reverse.detail-btn
      .mb-3
      .separator(style="border-top: 1px solid #606060;")
      .mb-3
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import {
  functionNameMap,
  Functions,
  ReceiveMessagesFunction,
  ReservationsFunction,
  reservationsFunctionNameMap,
  SendDocumentsFunction,
  SendMessagesFunction,
  WaiterReceiveMessagesFunction
} from "@/commons/services/Authorization";
import { PlanType } from "@/commons/services/Plans";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";
import FormInputStandardUserSendMessagesFunction from "@/pc/components/forms/FormInputStandardUserSendMessagesFunction.vue";
import FormInputStandardUserReceiveMessagesFunction from "@/pc/components/forms/FormInputStandardUserReceiveMessagesFunction.vue";
import FormInputStandardUserReservationsFunction from "@/pc/components/forms/FormInputStandardUserReservationsFunction.vue";
import FormInputStandardUserWaiterReceiveMessagesFunction from "@/pc/components/forms/FormInputStandardUserWaiterReceiveMessagesFunction.vue";
import FormInputStandardUserSendDocumentsFunction from "@/pc/components/forms/FormInputStandardUserSendDocumentsFunction.vue";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント
 */
@Component({
  components: {
    UsableFunctionSwitch,
    FormInputStandardUserSendMessagesFunction,
    FormInputStandardUserReceiveMessagesFunction,
    FormInputStandardUserReservationsFunction,
    FormInputStandardUserWaiterReceiveMessagesFunction,
    FormInputStandardUserSendDocumentsFunction
  }
})
export default class FormInputStandardUserFunctions extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: StandardUserFunctionsModel;

  /** メッセージ送信詳細表示可否（家族サービス） */
  showSendMessagesFunction: boolean = false;
  /** 受信メッセージ詳細表示可否（家族サービス） */
  showReceiveMessagesFunction: boolean = false;
  /** 面会予約詳細表示可否 */
  showReservationsFunction: boolean = false;
  /** 文書送付詳細表示可否 */
  showSendDocumentsFunction: boolean = false;

  /** メッセージ送信詳細表示可否（待機者サービス） */
  showWaiterSendMessagesFunction: boolean = false;
  /** 受信メッセージ詳細表示可否（待機者サービス） */
  showWaiterReceiveMessagesFunction: boolean = false;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): StandardUserFunctionsModel {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: StandardUserFunctionsModel) {
    this.$emit("input", newValue);

    return;
  }

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  get _useWaiterService(): boolean {
    return userStore.facility.useWaiterService && userStore.loginUser.permissions.functions.useWaiterService;
  }

  get _useOtherOfficeService(): boolean {
    return userStore.facility.useOtherOfficeConnectionService && userStore.loginUser.permissions.functions.useOtherOfficeConnectionService;
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### プラン(待機者)がベーシック以上かを返す */
  get _isOverWaiterBasicPlan(): boolean {
    const planType: WaiterServicePlanType = userStore.facility.waiterServicePlanType;

    if (WaiterServicePlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### 共通のカレンダー表示権限を表示するかを返す */
  get _showCommonreportsFunction(): boolean {
    // trueの数をカウントして、2つ以上であれば共通のカレンダーを表示する
    let trueCount = 0;
    if (this._useFamilyService) {
      trueCount++;
    }
    if (this._useWaiterService) {
      trueCount++;
    }
    if (this._useOtherOfficeService) {
      trueCount++;
    }
    return 2 <= trueCount; // trueの数が2以上であればtrueを返す
  }

  /**
   * ### サイドメニューの機能名を返す
   */
  public getFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = functionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }

  /**
   * ### 面会予約の項目名を返す
   */
  public getReservationsFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = reservationsFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }

  /**
   * ### メニュー表示可否を返す
   */
  public showMenuOfPermitted(functionName: string): boolean {
    // Objectのプロパティを動的参照したいが、コンパイルエラーになるのでanyにしてから取得する
    const permittedFunctions: any = userStore.facility.permittedFunctions;
    const showMenu: boolean = permittedFunctions[functionName];

    return showMenu;
  }

  /**
   * ### フリープラン以上か
   */
  public isOverFreePlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.FREE <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### ベーシックプラン以上か
   */
  public isOverBasicPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 受信メッセージの表示可否を返す
   */
  public showOpinionMessageMenu(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      if (userStore.facility.permittedFunctions.opinion == true) {
        return true;
      } else {
        return false;
      }
    }
  }

  public changeShowSendMessagesFunction(): void {
    this.showSendMessagesFunction = !this.showSendMessagesFunction;
    return;
  }

  public changeShowReceiveMessagesFunction(): void {
    this.showReceiveMessagesFunction = !this.showReceiveMessagesFunction;
    return;
  }

  public changeShowReservationsFunction(): void {
    this.showReservationsFunction = !this.showReservationsFunction;
    return;
  }

  public changeShowSendDocumentsFunction(): void {
    this.showSendDocumentsFunction = !this.showSendDocumentsFunction;
    return;
  }

  public changeShowWaiterSendMessagesFunction(): void {
    this.showWaiterSendMessagesFunction = !this.showWaiterSendMessagesFunction;
    return;
  }

  public changeShowWaiterReceiveMessagesFunction(): void {
    this.showWaiterReceiveMessagesFunction = !this.showWaiterReceiveMessagesFunction;
    return;
  }
}
export interface StandardUserFunctionsModel {
  functions: Functions;
  sendMessagesFunction: SendMessagesFunction;
  receiveMessagesFunction: ReceiveMessagesFunction;
  reservationsFunction: ReservationsFunction;
  waiterReceiveMessagesFunction: WaiterReceiveMessagesFunction;
  sendDocumentsFunction: SendDocumentsFunction;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.function {
  .service-title {
    .function-name {
      font-weight: bold;
    }
  }

  .content {
    margin-bottom: 8px;
  }

  .function-detail-name {
    margin-left: 16px;
  }
  .detail-btn {
    width: 78px;
    margin-left: 8px;

    .btn {
      text-align: left !important;
      width: 78px;
      font-size: 16px !important;
      height: 36px !important;
    }

    // 閉じているときはcllapsedクラスが付与されているので下矢印をつける
    &.collapsed {
      .toggle-text:after {
        @include svg-icon("../../../assets/chevron-down.svg", grey, 20px, 20px);
        float: right;
      }
    }
    // 閉じているときはcllapsedクラスが付与されないので上矢印をつける
    &.not-collapsed {
      .toggle-text:after {
        @include svg-icon("../../../assets/chevron-up.svg", grey, 20px, 20px);
        float: right;
      }
    }
  }

  // フッターのフェードイン/アウト
  .detail-btn-transition-enter-active {
    transition: opacity 1s;
  }
  .detail-btn-transition-leave-active {
    transition: opacity 0.2s;
  }
  .detail-btn-transition-enter,
  .detail-btn-transition-leave-to {
    opacity: 0;
  }
}
</style>
